import {useSyncExternalStore} from 'react';

import {aiAssistantPresentationStore} from '../store/aiAssistantPresentationStore';

export const useAiAssistantPresentation = () =>
  useSyncExternalStore(
    aiAssistantPresentationStore.subscribe,
    aiAssistantPresentationStore.getSnapshot,
    aiAssistantPresentationStore.getSnapshot
  );
